'use client';

import { c as _c } from "react/compiler-runtime";
import React, { type KeyboardEvent } from 'react';
import { AnimatedCounter } from '@src/components/AnimatedCounter/AnimatedCounter';
import { cn } from '@src/utils/tailwind';
interface NumberCountdownProps {
  textStyle: string;
  animated: boolean;
  selectedTimePeriod: number;
  builderBlock: any;
  animatedBackground: string;
  onClick?: () => Promise<void>;
  onKeyDown?: (e: KeyboardEvent) => Promise<void>;
  role?: string;
  tabIndex?: number;
}
export default function NumberCountdown(props) {
  const $ = _c(13);
  const {
    textStyle,
    animated,
    selectedTimePeriod,
    builderBlock,
    animatedBackground,
    role,
    tabIndex,
    onClick,
    onKeyDown
  } = props;
  let t0;
  if ($[0] !== onClick || $[1] !== onKeyDown || $[2] !== role || $[3] !== tabIndex) {
    t0 = {
      role,
      tabIndex,
      onClick,
      onKeyDown
    };
    $[0] = onClick;
    $[1] = onKeyDown;
    $[2] = role;
    $[3] = tabIndex;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const clickActionProps = t0;
  const currentStyles = builderBlock?.responsiveStyles?.large;
  let t1;
  if ($[5] !== animated || $[6] !== animatedBackground || $[7] !== clickActionProps || $[8] !== currentStyles?.color || $[9] !== currentStyles?.fontSize || $[10] !== selectedTimePeriod || $[11] !== textStyle) {
    t1 = <>{animated ? <div {...clickActionProps} className={cn("builder-text prose flex flex-row gap-1", textStyle)}><div className="rounded-sm p-1" style={{
          backgroundColor: animatedBackground
        }}><AnimatedCounter value={Math.floor(selectedTimePeriod / 10 % 10)} decimalPrecision={0} fontSize={currentStyles?.fontSize} color={currentStyles?.color} incrementColor={currentStyles?.color} decrementColor={currentStyles?.color} /></div><div className="rounded-sm p-1" style={{
          backgroundColor: animatedBackground
        }}><AnimatedCounter value={selectedTimePeriod % 10} decimalPrecision={0} fontSize={currentStyles?.fontSize} color={currentStyles?.color} incrementColor={currentStyles?.color} decrementColor={currentStyles?.color} /></div></div> : <span {...clickActionProps} className={cn("builder-text prose", textStyle)} suppressHydrationWarning={true}>{String(selectedTimePeriod).padStart(2, "0")}</span>}</>;
    $[5] = animated;
    $[6] = animatedBackground;
    $[7] = clickActionProps;
    $[8] = currentStyles?.color;
    $[9] = currentStyles?.fontSize;
    $[10] = selectedTimePeriod;
    $[11] = textStyle;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
}